export const formatTime = (value: string | number) => {
  return new Intl.DateTimeFormat("lv", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
};
